var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestRunInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.273193 0.000200272H19.3787V24H0.273193V0.000200272Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6257 0.000200272H2.02569C1.05769 0.000200272 0.272694 0.8102 0.272694 1.8092V22.1902C0.272694 23.1892 1.05769 24.0002 2.02569 24.0002H13.2477C11.2827 22.5852 9.99369 20.2372 9.99369 17.5762C9.99369 17.0342 10.0477 16.5052 10.1487 15.9932H6.90569C6.61369 15.9932 6.40469 15.7892 6.40469 15.5032V14.5212C6.40469 14.2762 6.61369 14.0312 6.90569 14.0312H10.8217C11.3427 12.9742 12.0897 12.0582 12.9967 11.3462H6.90569C6.61369 11.3462 6.40469 11.1422 6.40469 10.8552V9.8742C6.40469 9.6292 6.61369 9.3842 6.90569 9.3842H15.2497C15.4997 9.3842 15.7497 9.6292 15.7497 9.8742V9.9832C16.3377 9.8332 16.9477 9.7452 17.5797 9.7452C18.2007 9.7452 18.8017 9.8302 19.3787 9.9752V1.8092C19.3787 0.8102 18.5947 0.000200272 17.6257 0.000200272Z",
    fill: "#D2E1FA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2498 9.384H6.90579C6.61379 9.384 6.40479 9.629 6.40479 9.874V10.856C6.40479 11.142 6.61379 11.346 6.90579 11.346H12.9968C13.8048 10.712 14.7358 10.243 15.7498 9.984V9.874C15.7498 9.629 15.4998 9.384 15.2498 9.384Z",
    fill: "#3B7FF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40499 14.5217V15.5027C6.40499 15.7897 6.61399 15.9937 6.90599 15.9937H10.149C10.287 15.2997 10.519 14.6447 10.822 14.0317H6.90599C6.61399 14.0317 6.40499 14.2767 6.40499 14.5217Z",
    fill: "#3B7FF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8318 4.7365C18.1548 4.7365 18.4788 4.9815 18.4788 5.2265V6.2085C18.4788 6.4945 18.1548 6.6985 17.8318 6.6985H7.05179C6.67479 6.6985 6.40479 6.4945 6.40479 6.2085V5.2265C6.40479 4.9815 6.67479 4.7365 7.05179 4.7365H17.8318Z",
    fill: "#3B7FF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73509 4.5724C4.35209 4.5724 4.90309 5.1134 4.90309 5.7174C4.90309 6.3534 4.35209 6.8624 3.73509 6.8624C3.08609 6.8624 2.56709 6.3534 2.56709 5.7174C2.56709 5.1134 3.08609 4.5724 3.73509 4.5724Z",
    fill: "#3B7FF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73509 9.2199C4.35209 9.2199 4.90309 9.7609 4.90309 10.3649C4.90309 11.0009 4.35209 11.5099 3.73509 11.5099C3.08609 11.5099 2.56709 11.0009 2.56709 10.3649C2.56709 9.7609 3.08609 9.2199 3.73509 9.2199Z",
    fill: "#3B7FF5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 14,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8919 11.4403H24.2729V24H11.8919V11.4403Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9529 18.3273L16.5599 20.8853C16.1609 21.1133 15.6859 20.8353 15.6859 20.3533V15.0863C15.6859 14.6313 16.1609 14.3513 16.5599 14.5553L20.9529 17.2643C21.3779 17.5173 21.3779 18.0993 20.9529 18.3273ZM18.0829 11.4403C14.6629 11.4403 11.8919 14.2513 11.8919 17.7203C11.8919 21.1893 14.6629 24.0003 18.0829 24.0003C21.5029 24.0003 24.2729 21.1893 24.2729 17.7203C24.2729 14.2513 21.5029 11.4403 18.0829 11.4403Z",
    fill: "#B4CEFA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.273193)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestRunInactive);
export default __webpack_public_path__ + "static/media/test-run-inactive.b4c4cdd5d39169cc7ee149fe949a37e5.svg";
export { ForwardRef as ReactComponent };